import { FieldErrors } from 'react-hook-form';

import { IOfferCalculatorSubmitPayload, IFormState, TAnalytics } from 'shared/offerCalculator/types/calculator';

export enum ECalculatorEventName {
  onSubmit = 'offerCalculatorOnSubmit',
  onError = 'offerCalculatorOnError',
  onSendAnalytics = 'offerCalculatorOnSendAnalytic',
}

export type TEventPayload<T = undefined> = T extends undefined
  ? { description: string }
  : { description: string; data: T };

export interface ICalculatorWidgetEventMap {
  [ECalculatorEventName.onSubmit]: TEventPayload<IOfferCalculatorSubmitPayload>;
  [ECalculatorEventName.onError]: TEventPayload<FieldErrors<IFormState>>;
  [ECalculatorEventName.onSendAnalytics]: TEventPayload<TAnalytics>;
}
